import { useTranslation } from 'react-i18next';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';
import hasItems from '@/lib/utils/hasItems';

import useSelectedParty from '../analysis/hooks/useSelectedParty';

import DocumentItem from './components/DcoumentsSection/DocumentItem';
import useDocuments from './queries/hooks/useDocuments';

export default function DocumentsOverview() {
  const { t } = useTranslation();

  const party = useSelectedParty();

  const { data: documents, isLoading } = useDocuments(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>{t('DOCUMENTS_TITLE')}</SubPageHeader>

      <main className="flex flex-1 flex-col gap-2 overflow-y-auto p-2">
        {isLoading && <LoadingPage />}

        {!isLoading &&
          hasItems(documents) &&
          documents.map((document) => (
            <DocumentItem key={document.id} document={document} />
          ))}
      </main>
    </div>
  );
}
